import { Component, effect } from '@angular/core';
import { Validators } from '@angular/forms';
import { CipoControlBase } from '@shared/components/fields/cipo-control.base';
import { CipoTextViewComponent } from '@shared/components/fields/cipo-text-view/cipo-text-view.component';

import { CipoCheckboxConfig } from '@shared/components/fields/common';
import { CipoFormModule } from '@shared/modules/forms.module';
import { CipoOutlineFieldComponent } from '../cipo-outline-field/cipo-outline-field.component';

@Component({
  selector: 'cipo-checkbox',
  imports: [CipoFormModule, CipoTextViewComponent, CipoOutlineFieldComponent],
  templateUrl: './cipo-checkbox.component.html',
})
export class CipoCheckboxComponent extends CipoControlBase<boolean, CipoCheckboxConfig> {
  constructor() {
    super();
    effect(() => {
      if (this.deepFieldData.required()) {
        this.validators.set('requiredTrue', Validators.requiredTrue);
      } else {
        this.validators.delete('requiredTrue');
      }
      this.updateValidators();
    });
  }
}
